'use client';

import { Controller } from 'react-hook-form';
import { StarRating } from '@/shared/ui/star-rating';
import { FormFieldMessage } from './form-field-message';
import { FormFieldProps } from './types';
import { getFormFieldState } from './utils/getFormFieldState';

type Props = Omit<FormFieldProps<typeof StarRating>, 'value' | 'onChange'>;
export const FormStarRating = ({
    name,
    control,
    defaultValue,
    disabled,
    rules,
    shouldUnregister,
    messageWrapperProps,
    isErrorVisible = true,
    isSuccessVisible,
    ...props
}: Props) => {
    return (
        <Controller
            {...{ name, control, defaultValue, disabled, rules, shouldUnregister }}
            render={({ field: { onChange, value }, fieldState: { error, isDirty, isTouched, invalid } }) => {
                const state = getFormFieldState({
                    invalid,
                    isDirty,
                    isTouched,
                    isErrorVisible,
                    isSuccessVisible,
                });

                return (
                    <>
                        <StarRating value={value} onChange={onChange} disabled={disabled} {...props} />
                        <FormFieldMessage
                            state={state}
                            error={error}
                            messageWrapperProps={messageWrapperProps}
                        />
                    </>
                );
            }}
        />
    );
};
